<script>
import { ShoppingCart, Account } from './../../functions.js'
import PopupModal from './PopupModal.vue'
export default {
  name: 'QuickviewDialogue',
  components: { PopupModal },
   data: () => ({
        // Parameters that change depending on the type of dialogue
        product: {
            product_image: [],
            product_name: '',
            promo: [],
        },
        quantity: 1,
        status: 'success',
        message: '', // Main text content
 
        
        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
    }),
  created () {
   
  },
  methods: {
        show(opts = {}) {
            this.product = opts.product
            this.message = opts.message
            this.status = opts.status
           
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open()
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        _confirm() {
            this.$refs.popup.close()
            this.resolvePromise(true)
        },

        _cancel() {
            this.$refs.popup.close()
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User canceled the dialogue'))
        },

         plus()
        {
          if(this.quantity < parseInt(this.product.stock_on_hand))
            this.quantity += 1;
        },
        minus()
        {

            this.quantity = (this.quantity > 1 ? this.quantity-=1 : 1);
        },
        addToCart()
        {
            this.$refs.popup.close()
            this.resolvePromise({
                product: this.product,
                quantity: this.quantity
            })
    
            this.quantity = 1;
        },
         getProductPrice(product)
    {
      if(product.sale_type == 'default')
      {
        return (product.product_price);
      }
      else
      {
       
          var has_price_off_promo = false;
          var price_off_promo_index = 0;
          if(product.promo) {
            product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo))
              {
                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                {
                  price_off_promo_index = promo_index;
                  has_price_off_promo = true;
                }
              }
            });
          }
          
          if(has_price_off_promo)
          {
            var passed_product_requirements = 0;
            product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
              ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                if(p.product.sku == ri.sku_id)
                {
                  passed_product_requirements+=1;
                }
              });
            });

            if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
            {

               if(product.promo[price_off_promo_index].promo_minimum_amount)
                {
                  return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
                }
                else
                {
                   return (product.sale_price);
                }
            }
            else
            {
               return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
            }

          }
          else
          {
               return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
          }

       

      }
     

      // if(product.sale_type == 'fixed' || product.sale_type == 'percentage' || product.sale_type == 'promo')
      // {
      //   if(product.sale_type == 'promo')
      //   {

      //     var has_price_off_promo = false;
      //     var price_off_promo_index = 0;
      //     product.promo.forEach((promo, promo_index)=>{
      //       if(typeof promo == 'object' && !Array.isArray(promo))
      //       {
      //         if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //         {
      //           price_off_promo_index = promo_index;
      //           has_price_off_promo = true;
      //         }
      //       }
      //     });
          
      //     if(has_price_off_promo)
      //     {
      //       var passed_product_requirements = 0;
      //       product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
      //         ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //           if(p.product.sku == ri.sku_id)
      //           {
      //             passed_product_requirements+=1;
      //           }
      //         });
      //       });

      //       if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
      //       {

      //          if(product.promo[price_off_promo_index].promo_minimum_amount)
      //           {

      //             return (product.product_price);
      //           }
      //           else
      //           {

      //             return  (product.sale_price );
      //           }
      //       }
      //       else
      //       {

      //         return  (product.product_price);
      //       }

      //     }
      //     else
      //     {

      //         return (product.product_price);
      //     }

      //   }
      //   else
      //   {
      //     return (product.sale_price);
      //   }

      // }
      // else
      // {
      //   return (product.product_price);
      // }

    },
    hasProductPromo(product)
    {

      if(product.promo && product.promo.length)
      {
         return true;
      }
      else
      {
        return null;
      }

    },
    getProductSlashedPrice(product)
    {

      if(product.sale_type == 'default')
      {
        return 0;
      }
      else
      {
          var has_price_off_promo = false;
          var price_off_promo_index = 0;
          if(product.promo) {
            product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo)){
                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                {
                  price_off_promo_index = promo_index;
                  has_price_off_promo = true;
                }
              }
            });
          }


          if(has_price_off_promo)
          {
              var passed_product_requirements = 0;
              product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
                ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                  if(p.product.sku == ri.sku_id)
                  {
                    passed_product_requirements+=1;
                  }
                });
              });

              if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
              {
                  if(product.promo[price_off_promo_index].promo_minimum_amount)
                  {
                    return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
                  }
                  else
                  {
                    return (product.original_price);
                  }
                 
              }
              else
              {
                return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
              }
         

          }
          else
          {
           return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
          }

        }

    


      // if(product.sale_type == 'fixed' || product.sale_type == 'percentage' || product.sale_type == 'promo')
      // {
      //   if(product.sale_type == 'promo')
      //   {

      //     var has_price_off_promo = false;
      //     var price_off_promo_index = 0;
      //     product.promo.forEach((promo, promo_index)=>{
      //       if(typeof promo == 'object' && !Array.isArray(promo)){
      //         if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //         {
      //           price_off_promo_index = promo_index;
      //           has_price_off_promo = true;
      //         }
      //       }
      //     });


      //     if(has_price_off_promo)
      //     {
      //         var passed_product_requirements = 0;
      //         product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
      //           ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //             if(p.product.sku == ri.sku_id)
      //             {
      //               passed_product_requirements+=1;
      //             }
      //           });
      //         });

      //         if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
      //         {
      //             if(product.promo[price_off_promo_index].promo_minimum_amount)
      //             {
      //               return  0;
      //             }
      //             else
      //             {
      //               return  (product.original_price);
      //             }
                 
      //         }
      //         else
      //         {
      //           return  (0);
      //         }
         

      //     }
      //     else
      //     {
      //       return (0);
      //     }

      //   }
      //   else
      //   {
      //     return (product.original_price);
      //   }

      // }
      // else
      // {
      //   return (0);
      // }
    }
  }
}
</script>

<template>

    <!-- MODAL AREA START (Add To Cart Modal) -->
      <popup-modal ref="popup">
           <div class="modal-content ltn__modal-area ltn__quick-view-modal-area">
                    <div class="modal-header">
                        <button type="button" class="close"  @click="_cancel()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            <!-- <i class="fas fa-times"></i> -->
                        </button>
                    </div>
                    <div class="modal-body">
                         <div class="ltn__quick-view-modal-inner">
                             <div class="modal-product-item">
                                <div class="row">
                                    <div class="col-lg-6 col-12">
                                        <div class="modal-product-img">
                                            <img :src="product.product_image[0]" alt="#">
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-12">
                                        <div class="modal-product-info">
                                            <!-- <div class="product-ratting">
                                                <ul>
                                                    <li><a href="#"><i class="fas fa-star"></i></a></li>
                                                    <li><a href="#"><i class="fas fa-star"></i></a></li>
                                                    <li><a href="#"><i class="fas fa-star"></i></a></li>
                                                    <li><a href="#"><i class="fas fa-star-half-alt"></i></a></li>
                                                    <li><a href="#"><i class="far fa-star"></i></a></li>
                                                    <li class="review-total"> <a href="#"> ( 95 Reviews )</a></li>
                                                </ul>
                                            </div> -->
                                            <h3>{{ product.product_name }}</h3>
                                             <div class="product-price">
                                                <span>
                                                  {{ getProductPrice(product) | currencyFormat }} </span>
                                                <del v-if=" getProductSlashedPrice(product) > 0">
                                                <span >{{ getProductSlashedPrice(product) | currencyFormat }}</span>
                                                </del>
                                            </div>
                                             <div class="promo-details" v-if="hasProductPromo(product)">
                                                 <small v-for="promo of product.promo">{{  promo.promo_description }}<br></small>
                                             </div>
                                            <div class="modal-product-meta ltn__product-details-menu-1">
                                                <!-- <ul>
                                                    <li>
                                                        <strong>Category:</strong>
                                                        <span>
                                                            <a href="#">{{ product.main_category_name }}</a>
                                                        </span>
                                                    </li>
                                                </ul> -->
                                                <small>({{ product.stock_on_hand }} Available)</small>
                                            </div>
                                            <div class="ltn__product-details-menu-2">
                                                <ul>
                                                    <li>
                                                        <div class="cart-plus-minus">
                                                            <div class="dec qtybutton" @click="minus">-</div>
                                                            <input type="text" v-model="quantity" value="1" name="qtybutton" readonly class="cart-plus-minus-box">
                                                            <div class="inc qtybutton" @click="plus">+</div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <button class="theme-btn-1 btn btn-effect-1" title="Add to Cart" @click="addToCart">
                                                            <i class="fas fa-shopping-cart"></i>
                                                            <span>ADD TO CART</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="ltn__product-details-menu-3">
                                                <!-- <ul>
                                                    <li>
                                                        <a @click="addToWishlist" class="" title="Wishlist">
                                                            <i class="far fa-heart"></i>
                                                            <span>Add to Wishlist</span>
                                                        </a>
                                                    </li>
                                                </ul> -->
                                            </div>
                                            <hr>
                                            <div class="ltn__social-media">
                                                <ul>
                                                    <li>Share:</li>
                                                    <li><a class="social-media" href="#" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
                                                    <li><a class="social-media" href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>
                                                    <li><a class="social-media" href="#" title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
                                                    <li><a class="social-media" href="#" title="Instagram"><i class="fab fa-instagram"></i></a></li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                             </div>
                         </div>
                    </div>
                </div>

     </popup-modal>
    <!-- MODAL AREA END -->
</template>
<style scoped>
.modal-content
{
    border: 0px;
}
.modal-content.ltn__modal-area.ltn__quick-view-modal-area {
    max-width: 860px;
}
.promo-details {
    text-align: left;
    font-size: 1rem;
    font-style: italic;
    color: #e3201b;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/QuickviewDialogue.vue